module.exports = __webpack_public_path__ + "static/media/titanic.61e23185.jpg";